exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".multi-line[data-v-01e386b0]{color:#f35050;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;width:130px}", "", {"version":3,"sources":["/workspace/src/views/batch-jobs/pages/FinanceBatchJobTable.vue"],"names":[],"mappings":"AACA,6BAA6B,cAAc,oBAAoB,4BAA4B,qBAAqB,gBAAgB,WAAW,CAC1I","file":"FinanceBatchJobTable.vue","sourcesContent":["\n.multi-line[data-v-01e386b0]{color:#f35050;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;width:130px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01e386b0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/batch-jobs/pages/FinanceBatchJobTable.vue
// module id = 3293
// module chunks = 172